import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { startOrder, commitOrder } from "../ducks/shoppingCartSlice";
import { trackAddToCart } from "../ducks/tracking";
import useToast from "./useToast";
import { selectLayout } from "../ducks/shopSelectors";

/**
 * O "+" do card de produto: põe o item direto na sacola, sem abrir a tela do
 * produto, quando não há nada para o cliente decidir.
 *
 * Só vale para produto sem perguntas (nem opcionais: o cliente perderia a
 * chance de escolhê-las), vendido por unidade, e fora dos aparelhos de
 * autoatendimento (totem, tablet, POS), que têm fluxo próprio. Bebida alcoólica só depois que o cliente já confirmou a
 * maioridade na tela do produto. Nos outros casos, o "+" abre o produto.
 */
export default function useQuickAdd() {
  const dispatch = useDispatch();
  const { toastSuccess } = useToast();
  const { isAvailableToOrder, user18Older, kilogramStep } = useSelector(
    (state) => state.shop,
  );
  const { sharedDevice } = useSelector(selectLayout);

  const canQuickAdd = (product) =>
    !!isAvailableToOrder &&
    !sharedDevice &&
    !product.disabled &&
    !product.isKilogram &&
    !product.pizza &&
    (product.questionsIds || []).length === 0 &&
    (!product.isAlcoholic || user18Older);

  // `upsell`: adicionado pelo "Peça também" da sacola
  const quickAdd = (product, { upsell = false } = {}) => {
    const uuid = uuidv4();
    dispatch(startOrder({ uuid, productId: product.id, kilogramStep, upsell }));
    dispatch(commitOrder({ uuid }));
    toastSuccess("Produto adicionado!");
    dispatch(trackAddToCart(uuid));
  };

  return { canQuickAdd, quickAdd };
}
